module.exports = __webpack_public_path__ + "img/verify.5d60e6e8.svg";